import appLocaleData from 'react-intl/locale-data/fr';
import chMessages from '../locales/fr-FR';

const FrLang = {
    messages: {
        ...chMessages
    },
    locale: 'fr-FR',
    data: appLocaleData
};
export default FrLang;